const swiperComponent = class extends HTMLElement {
    swiper = this.querySelector('.swiper-container');
 
    connectedCallback() { 
        this._initSwiper();
        $(document).on('quick-buy-popover:change:end', e => this._initSwiper(e));
    }

    _initSwiper(e) {  
        const swiper = new Swiper(this.swiper, {
            slidesPerView: this.swiper.getAttribute('slides-per-view') || 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next', 
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
            
        }); 
 
    }
};

window.customElements.define('swiper-component', swiperComponent);
